module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }), _vm._v("First published in 1998 by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Samuel Weiser, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Box 612")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("York Beach, ME 03910-0612")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Copyright © 1998 Thomas Cleary")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from Samuel Weiser, Inc. Reviewers may quote brief passages.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpageparacenter"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Cleary, Thomas.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara1"
  }, [_vm._v("The ecstasy of enlightenment : teachings of natural Tantra / translated from the old Bengali with commentary [by] Thomas Cleary.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara2"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara1"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara1"
  }, [_vm._v("ISBN 1-57863-027-4 (paper : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara1"
  }, [_vm._v("1. Tantric Buddhism—Prayer books and devotions—History and criticism. 2. Tantric Buddhism—Doctrines. 3. Spiritual life—Tantric Buddhism. 4. Tantric Buddhism—India—Bengal. 5. Bengal (India)—Religion.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("BQ8939.5.C54 1998")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("294.3'925—dc21")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepararight"
  }, [_vm._v("97-43967")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepararight"
  }, [_vm._v("CIP")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("BJ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Typeset in 10 point Utopia")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Cover illustration is a detail from a Chinese handscroll of the Ch'ing dynasty, “Flowers and Butterflies” by Ma Ch'uan (1720–1800). Used by permission of The Metropolitan Museum of Art, Fletcher Fund, 1947 (47.18.116). Photograph copyright © 1979 The Metropolitan Museum of Art.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("07 06 05 04 03 02 01 00 99 98")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_vm._v("The paper used in this publication meets the minimum requirements of the American National Standard for Permanence of Paper for Printed Library Materials Z39.48–1984.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_c('a', {
    attrs: {
      "href": "http://www.redwheelweiser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.redwheelweiser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpagepara"
  }, [_c('a', {
    attrs: {
      "href": "http://www.redwheelweiser.com/newsletter",
      "target": "_blank"
    }
  }, [_vm._v("www.redwheelweiser.com/newsletter")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a96ff83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02copyright.vue
// module id = 60
// module chunks = 0